import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Input, ErrorMessage } from '../styles';

const PasswordInput = (props) => {
  const {
    onChange,
    onFocus,
    onBlur,
    errors,
    touched,
    name,
    type,
    onShowPasswordClick,
  } = props;
  return (
    <>
      <Input
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        fluid
        type={type}
        error={_.get(errors, name) && _.get(touched, name)}
        icon={{
          link: true,
          name: type === 'password' ? 'eye' : 'eye slash',
          onClick: onShowPasswordClick,
        }}
      />
      <ErrorMessage>
        {_.get(errors, name) && _.get(touched, name) && _.get(errors, name)}
      </ErrorMessage>
    </>
  );
};

PasswordInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  onShowPasswordClick: PropTypes.func.isRequired,
};

export default PasswordInput;
